var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    {
      staticClass:
        "skill__label self-center text-low-xs border border-gray-500 rounded-2xl px-2 py-0.5",
    },
    [_vm._v(" " + _vm._s(_vm.labelText) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }